import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { Link } from 'react-router-dom';


const Body = ({ purchaseOrderReceiver, branches, beginDate, endDate }) => {
    return (
        <div id="taxSummaryReport">
            {
                purchaseOrderReceiver.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    purchaseOrderReceiver.length > 0 &&
                    //If there's DATA
                    <div>

                        {/* TRANSACTIONS */}

                        {/*<div id="product-list-table">
                    <CardSimple>*/}
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : ""}
                            </div>
                        </div>

                        <div >
                            {
                                purchaseOrderReceiver.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0 odd_bgcolor" key={index}>
                                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 mb-1 d-flex">
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                    <label>Record Type</label>
                                                    {item.recordType}
                                                </div> {/* Column Orders */}
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                    <label>Branch</label>
                                                    <h6 className="m-0">{(item.branchName)}</h6>
                                                    <label>Vendor</label>
                                                    <h6 className="m-0">{(item.vendorName)}</h6>
                                                    <label>Supplier Invoice</label>
                                                    <h6 className="m-0">{(item.supplierInvoiceNumber)}</h6>
                                                </div> {/* Column Orders */}
                                                <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                                    <label>PO #</label>
                                                    <Link to={`/purchaseOrder/edit/${item.poId}`}><h5 className="m-0">{(item.poId)}</h5></Link>
                                                </div> {/* Column Orders */}
                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                    <label>Product Name</label>
                                                    <h6 className="m-0">{(item.productName)}</h6>
                                                    <label>Category</label>
                                                    <h6 className="m-0">{(item.categoryName)}</h6>
                                                    <label>SubCategory</label>
                                                    <h6 className="m-0">{(item.subCategoryName)}</h6>
                                                </div> {/* Column Orders */}
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                    <label>SKU</label>
                                                    <h6 className="m-0">{(item.sku)}</h6>
                                                    <label>Package Reference</label>
                                                    <h6 className="m-0">{(item.packageReference)}</h6>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                    <label className="sm_label">Employee Name</label>
                                                    <h6 className="m-0">{item.employeeName}</h6>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-1 d-flex">
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                        <label>Quantity</label>
                                                        <h6 className="m-0">{item.actualQuantity}</h6>
                                                        <label>Order Quantity</label>
                                                        <h6 className="m-0">{item.quantity}</h6>
                                                    </div>{/* Column Orders */}
                                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                        <label>Date</label>
                                                        <h6 className="m-0">{moment(item.modifiedDate).format('MMMM Do, YYYY')}</h6>
                                                        <label>Expiration Date</label>
                                                        <h6 className="m-0">{item.expirationDate !== null ? moment(item.expirationDate).format('MMMM Do, YYYY') : ""}</h6>
                                                    </div>{/* Column Orders */}
                                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                        <label>Unit Price</label>
                                                        <h6 className="m-0">{getDollarFormat(item.unitPrice)}</h6>
                                                    </div>{/* Column Orders */}
                                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                        <label>Total Cost</label>
                                                        <h6 className="m-0">{getDollarFormat(item.totalCost)}</h6>
                                                    </div>{/* Column Orders */}

                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }

                        </div>
                        {/*</CardSimple>
                </div>*/}

                    </div>
            }
        </div>
    );
};

export default Body;
